import { intl, ui } from '@beelday/common'
import styled from '@emotion/styled'
import { FC } from 'react'
import { KnowledgeCheckID } from './knowledge-check'
import KnowledgeCheckResultQuestions from './knowledge-check-result-questions'
import KnowledgeCheckResultScore from './knowledge-check-result-score'
import { useKnowledgeCheckResults } from './use-knowledge-check-results'

const Container = styled.div`
	align-items: center;
	align-self: center;
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 100%;
	overflow: auto;
	padding: 32px 40px;
	scrollbar-gutter: stable;
`

type Props = {
	knowledgeCheckId: KnowledgeCheckID
	useCorrectAnswers: boolean
}

const KnowledgeCheckResult: FC<Props> = ({
	knowledgeCheckId,
	useCorrectAnswers,
}) => {
	const { results, error, reload } = useKnowledgeCheckResults(knowledgeCheckId)

	return (
		<Container>
			{error ? (
				<ui.ErrorInline retry={reload}>
					<intl.Translate>knowledge_check.error.load</intl.Translate>
				</ui.ErrorInline>
			) : results ? (
				<>
					{useCorrectAnswers ? (
						<KnowledgeCheckResultScore knowledgeCheckScore={results.scoreDto} />
					) : null}
					<KnowledgeCheckResultQuestions
						knowledgeCheckQuestions={results.questions}
						useCorrectAnswers={useCorrectAnswers}
					/>
				</>
			) : null}
		</Container>
	)
}

export default KnowledgeCheckResult
